export enum PaymentMethodSettingsResponseKeys {
    DailyLimit = 'daily_limit',
    UpToThresholdCommissionRate = 'up_to_threshold_commission_rate',
    EqualOrAboveThresholdCommissionRate = 'equal_or_above_threshold_commission_rate',
    ThresholdOrderAmount = 'threshold_order_amount'
}

export enum PaymentMethodSettingsKeys {
    DailyLimit = 'dailyLimit',
    UpToThresholdCommissionRate = 'upToThresholdCommissionRate',
    EqualOrAboveThresholdCommissionRate = 'equalOrAboveThresholdCommissionRate',
    ThresholdOrderAmount = 'thresholdOrderAmount'
}

export const PAYMENT_METHOD_SETTINGS_RESPONSE_KEYS_MAP = {
    [PaymentMethodSettingsResponseKeys.DailyLimit]: PaymentMethodSettingsKeys.DailyLimit,
    [PaymentMethodSettingsResponseKeys.UpToThresholdCommissionRate]:
        PaymentMethodSettingsKeys.UpToThresholdCommissionRate,
    [PaymentMethodSettingsResponseKeys.EqualOrAboveThresholdCommissionRate]:
        PaymentMethodSettingsKeys.EqualOrAboveThresholdCommissionRate,
    [PaymentMethodSettingsResponseKeys.ThresholdOrderAmount]: PaymentMethodSettingsKeys.ThresholdOrderAmount
};
